import React from "react";
import ShopHero from "./shopHero";
import Shop from "./shop";

export default function ShopMain() {
  return (
    <>
      <ShopHero />
      <Shop />
    </>
  );
}
